import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { installGtag, trackPageview } from './analytics';

export default function GoogleAnalytics() {
  const location = useLocation();

  useEffect(() => {
    installGtag();
  }, []);

  useEffect(() => {
    trackPageview(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
